// Role object for dot notation access
export const Auth0Roles = {
  SYS_ADMIN: "System Admin",
  GIS_CONTRIBUTOR: "GIS Contributor",
  ORGANIZATION_ADMIN: "Organization Admin",
  VIEWER: "Viewer",
  DECREE_AGENT: "Decree Agent",
  PERMIT_REQUESTER: "Permit Requester",
} as const;

export const Roles = {
  ...Auth0Roles,
  CLIENT: "Client",
  ALL: "All",
} as const;

// Role type
export type RoleType = (typeof Roles)[keyof typeof Roles];
